import PropTypes from 'prop-types'

import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {BASE_CLASS} from '../../config.js'

const PanelPriceIndicatorTitle = ({description}) => {
  return (
    <>
      <div className={`${BASE_CLASS}-title`}>
        <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title="Análisis de precio" />
      </div>
      <p className={`${BASE_CLASS}-description`}>{description}</p>
    </>
  )
}

PanelPriceIndicatorTitle.displayName = 'PanelPriceIndicatorTitle'

PanelPriceIndicatorTitle.propTypes = {
  description: PropTypes.string
}

export default PanelPriceIndicatorTitle
